import { createContext } from "react";

/** Antwort aus einer Erwähnung: Absender wird im Notizfeld schon erwähnt. */
export interface ProjectOverviewReplyDraft {
  key: string;
  authorLogin?: string | null;
  authorDisplay?: string | null;
}

export interface ProjectOverviewOpenOptions {
  highlightNoteId?: number;
  openMontageunterlagen?: boolean;
  stuecklisteId?: number;
  replyDraft?: ProjectOverviewReplyDraft | null;
}

export interface ProjectOverviewContextValue {
  open: (auftragId: number, options?: ProjectOverviewOpenOptions) => void;
  close: () => void;
  isOpen: boolean;
  activeId: number | null;
  highlightNoteId: number | null;
  replyDraft: ProjectOverviewReplyDraft | null;
  openMontageunterlagen: boolean;
  stuecklisteId: number | null;
}

export const ProjectOverviewContext = createContext<ProjectOverviewContextValue | null>(null);
